/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import html2pdf from 'html2pdf.js';
import store from '@/store';
import * as XLSX from "xlsx";
import groupbarchart from '../../custom_lib/AiCharts/cmbarchart.vue';
import advtable from '../../custom_lib/AiCharts/advenenttable.vue';
import historytab from '../../custom_lib/AiCharts/historytab.vue';
import barchart from '../../custom_lib/AiCharts/adbarchart.vue';
import chartdrill from '../../custom_lib/AiCharts/popupfiles/chartdrillPopup.vue';
import stackedgroup from '../../custom_lib/AiCharts/SimpleStackedBarchart.vue';
import simplepiechart from '../../custom_lib/AiCharts/simplepiechart.vue';
import simplegrouplinechart from '../../custom_lib/AiCharts/simplegrouplinechart.vue'
export default {
  name: "labresultsreport",
  components: {
    groupbarchart,
    advtable,
    historytab,
    chartdrill,
    barchart,
    stackedgroup,
    simplepiechart,
    simplegrouplinechart
  },
  props: {
    templateId: {
      type: String,
      default: ''
    },
    resultCount: {
      type: Object,
      default: () => ({
        noOfSubjects: 0,
        noOfSubjectsEnrolledByAI: 0,
        noOfSubjectsRejectedByAI: 0
      }),
    },
    fromPage:{
      type:String,
      default:""
    },
  },
  async unmounted() {
    store.dispatch("setCollapse", false);
  },
  async mounted() {
    store.dispatch("setCollapse", true);
    this.data = this.sampledata.costBySite;
    this.graphdata = this.sampledata.costBySite;
    window.addEventListener("studyIdChanged", (event) => {
      this.historykeys=[];
      this.historydata={};
    this.targetValue=this.resultCount.noOfSubjects
    this.startRolling();
  });
    this.targetValue=this.resultCount.noOfSubjects
    this.startRolling();
  },
  data() {
    return {
      namesobj:{
        country:"Country",
        siteName:"Site Name",
        baselineCost:"Baseline Cost",
        actualCost:"Actual Cost",
        mild:"Mild",
        moderate:"Moderate",
        severe:"Severe"
      },
      barchartgroups:["baselineCost","actualCost"],
      stacks:["mild","moderate","severe"],
      sampledata:{
        "totalCost": {
          "mild": 480000,
          "moderate": 1000000,
          "severe": 1200000
        },
        "costBySite": [
          {
            "country": "UK",
            "siteName": "100",
            "baselineCost": 220000,
            "actualCost": 200000,
            "mild": 50000,
            "moderate": 100000,
            "severe": 50000
          },
          {
            "country": "UK",
            "siteName": "200",
            "baselineCost": 120000,
            "actualCost": 150000,
            "mild": 40000,
            "moderate": 80000,
            "severe": 30000
          },
          {
            "country": "UK",
            "siteName": "300",
            "baselineCost": 180000,
            "actualCost": 220000,
            "mild": 60000,
            "moderate": 100000,
            "severe": 60000
          },
          {
            "country": "UK",
            "siteName": "400",
            "baselineCost": 210000,
            "actualCost": 180000,
            "mild": 50000,
            "moderate": 90000,
            "severe": 40000
          },
          {
            "country": "UK",
            "siteName": "500",
            "baselineCost": 220000,
            "actualCost": 190000,
            "mild": 40000,
            "moderate": 100000,
            "severe": 50000
          },
          {
            "country": "UK",
            "siteName": "600",
            "baselineCost": 240000,
            "actualCost": 240000,
            "mild": 70000,
            "moderate": 120000,
            "severe": 50000
          },
          {
            "country": "USA",
            "siteName": "700",
            "baselineCost": 200000,
            "actualCost": 210000,
            "mild": 50000,
            "moderate": 110000,
            "severe": 50000
          },
          {
            "country": "USA",
            "siteName": "800",
            "baselineCost": 200000,
            "actualCost": 230000,
            "mild": 60000,
            "moderate": 120000,
            "severe": 50000
          },
          {
            "country": "USA",
            "siteName": "900",
            "baselineCost": 150000,
            "actualCost": 200000,
            "mild": 50000,
            "moderate": 100000,
            "severe": 50000
          },
          {
            "country": "India",
            "siteName": "101",
            "baselineCost": 200000,
            "actualCost": 170000,
            "mild": 40000,
            "moderate": 90000,
            "severe": 40000
          },
          {
            "country": "India",
            "siteName": "201",
            "baselineCost": 280000,
            "actualCost": 250000,
            "mild": 70000,
            "moderate": 130000,
            "severe": 50000
          },
          {
            "country": "India",
            "siteName": "301",
            "baselineCost": 200000,
            "actualCost": 190000,
            "mild": 50000,
            "moderate": 100000,
            "severe": 40000
          },
          {
            "country": "India",
            "siteName": "401",
            "baselineCost": 150000,
            "actualCost": 160000,
            "mild": 40000,
            "moderate": 80000,
            "severe": 40000
          },
          {
            "country": "India",
            "siteName": "501",
            "baselineCost": 150000,
            "actualCost": 180000,
            "mild": 50000,
            "moderate": 90000,
            "severe": 40000
          },
          {
            "country": "India",
            "siteName": "601",
            "baselineCost": 250000,
            "actualCost": 220000,
            "mild": 60000,
            "moderate": 110000,
            "severe": 50000
          }
        ],
        "trendOverTime": [
    {
      "period": "Q1 2024",
      "mild": 120000,
      "moderate": 250000,
      "severe": 300000,
      "totalAEManagementCost": 670000
    },
    {
      "period": "Q2 2024",
      "mild": 130000,
      "moderate": 260000,
      "severe": 310000,
      "totalAEManagementCost": 700000
    },
    {
      "period": "Q3 2024",
      "mild": 140000,
      "moderate": 280000,
      "severe": 320000,
      "totalAEManagementCost": 740000
    },
    {
      "period": "Q4 2024",
      "mild": 150000,
      "moderate": 300000,
      "severe": 330000,
      "totalAEManagementCost": 780000
    }
  ]
      },
      groupwidth:1200,
      arrayofkeys:[ ],
    customcolors:[
        '#1AB394', '#FF5252', '#ABF0FF', '#C1D1FF', '#FBD164', '#FDAD73'
      ],
      prioritycustomcolors:[
        '#f3b600', '#1AB394', '#FF5252', '#C1D1FF', '#FBD164', '#FDAD73'
      ],
    groupchartkeys:{
      "xaxiskey":"siteCode",
    "groupkey":"queryStatus",
    },
    grouplinechartkeys:{
        "xaxiskey":"createdAt",
      "groupkey":"queryStatus",
      },
      yValues:["Abnormal","Normal","High","Low"],
      maximizedcomp:"",
      drilldata:{},
      loader:true,
      expandBlock:false,
      data:[],
      graphdata:[],
      querydata:[],
      datahistory:[],
      columns:[],
      historykeys:[],
      historydata:{},
      drilldowndata:[],
      currentValue: 0, // Start value
      targetValue: 0, // The target value you want to roll to
      duration: 2000, // Duration of the animation in milliseconds
      displayValue: 0,
      basetestUrl: process.env.VUE_APP_Service_URL,
      baseUrl: process.env.VUE_APP_Service_URL + "/forms-ml/patientenroll/",
      selectedChartType: 'Comparitive Bar chart',
      chartTypes: ['Comparitive Bar chart', 'Pie Chart', 'Bar Chart', 'Line Chart',],
      drillpopup: false,
      colorcodes:[
        {
            "color":"#A0D568",
            "type":"mild"
        },{
            "color":"#FFCE54",
            "type":"moderate"
        },
        {
            "color":"#FF6663",
            "type":"severe"
        }
      ],
      barcolorcodes:[
        {
            "color":"#62b2fd",
            "type":"Baseline Cost"
        },{
            "color":"#9bdfc4",
            "type":"Actual Cost"
        }
      ],
      barprioritycolorcodes:[
        {
          "color":"#f3b600",
          "type":"Medium"
      },{
          "color":"#1AB394",
          "type":"Low"
      },
      {
        "color":"#FF5252",
        "type":"High"
    }
      ],
      xaxiskeys:{
        "horizondalpercent":"",
        "groupbarchart":"",
        "barchart":"",
        "histogram":"",
        "piechart":"AESEV",
        "advtable":"",
        "aepiechart":"",
        "historytab":"",
        "chartdrill":""}
    };
  },
  methods: {
    async exporttoexcell() {
      const worksheet = XLSX.utils.json_to_sheet(this.sampledata.costBySite);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "AE Cost Monitoring.xlsx");
    },
    exporttopdf() {
      // Create a temporary container
      const pdfContainer = document.createElement('div');
      const pdfContainer1 = document.createElement('div');
      const pdfContainer2 = document.createElement('div');
      const pdfContainer3 = document.createElement('div');
      const pdfContainer4 = document.createElement('div');
      const pdfContainer5 = document.createElement('div');

      const captureArea1 = this.$refs.captureArea1.cloneNode(true);
      const captureArea2 = this.$refs.captureArea2.cloneNode(true);
      const captureArea3 = this.$refs.captureArea3.cloneNode(true);
      const captureArea4 = this.$refs.captureArea4.cloneNode(true);
      const captureArea5 = this.$refs.captureArea5.cloneNode(true);

      captureArea2.classList.add('page-break');
      captureArea3.classList.add('page-break');
      captureArea4.classList.add('page-break');
      captureArea5.classList.add('page-break');
      // Append cloned elements to the container
      pdfContainer1.appendChild(captureArea1);
      pdfContainer2.appendChild(captureArea2);
      pdfContainer3.appendChild(captureArea3);
      pdfContainer4.appendChild(captureArea4);
      pdfContainer5.appendChild(captureArea5);
      
      // Optionally style the container for PDF formatting
     
      pdfContainer1.style.width = '100%';
      pdfContainer2.style.width = '200%';
      pdfContainer3.style.width = '200%';
      pdfContainer4.style.width = '200%';
      pdfContainer5.style.width = '150%';
      
      pdfContainer.appendChild(pdfContainer1);
      pdfContainer.appendChild(pdfContainer2);
      pdfContainer.appendChild(pdfContainer3);
      pdfContainer.appendChild(pdfContainer4);
      pdfContainer.appendChild(pdfContainer5);

      pdfContainer.style.display = 'block';
      // Set the options for html2pdf
      const opt = {
        margin: 0,
        filename: 'AE Cost Monitoring.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' }
      };
    
      // Convert the temporary container to PDF
      html2pdf().set(opt).from(pdfContainer).save();
    },
    async retaingroupchartvars(groupvars){
      if(groupvars.xaxiskey!="" && groupvars.groupkey!=""){
      this.groupchartkeys = groupvars;
      }
    },
    async retainvisitkey(xaxiskey){
      if(xaxiskey!=""){
      this.xaxiskeys["horizondalpercent"] = xaxiskey;
      }
    },
    startRolling() {
      const start = this.currentValue;
      const end = this.targetValue;
      const duration = this.duration;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        if (elapsedTime < duration) {
          const progress = elapsedTime / duration;
          this.displayValue = Math.floor(start + progress * (end - start));
          requestAnimationFrame(animate);
        } else {
          this.displayValue = end;
        }
      };

      requestAnimationFrame(animate);
    },
    async undobutton(){
      if(this.datahistory.length > 1){
      this.datahistory.pop();
      this.data=this.datahistory[this.datahistory.length-1];
      }
    },
    changetomaxcomponent(compval){
      this.maximizedcomp = compval;
    },
    changetominomponent(){
      this.maximizedcomp = "";
    },
    async onclosed(){
      this.drillpopup = false;
    },
    async drillpopupopened(datafromchild) {
      this.drilldata = datafromchild;
      this.drillpopup = true;

    },
    async drilldowncurrentchart(datafromchild){
      this.data = datafromchild;
      this.datahistory.push(this.data);
    },
    async filtereddata(filteredData){
      this.data=filteredData;
    },
    async drilldowncurrentchartforbar(datafromchild){
      const lastkey = this.historykeys[this.historykeys.length - 1];
      // this.data = datafromchild.sortedData;
      if(this.historydata[lastkey].length != datafromchild.sortedData.length){
      // if(!this.historykeys.includes(datafromchild.filterkeyword)){
       this.historykeys.push(datafromchild.filterkeyword);
      this.historydata[datafromchild.filterkeyword] = datafromchild.sortedData;
      this.data = this.historydata[datafromchild.filterkeyword];
      }
    },
    async gotohistorylevel(history){
      this.deleteAfterKeyvaluearrays(history);
      this.deleteAfterKeyarrays(history);
      this.data = this.historydata[history];
    },
    async deleteAfterKeyvaluearrays(selectedKey) {
      const entries = Object.entries(this.historydata); // Convert the object to an array of entries
      const selectedIndex = entries.findIndex(([key, value]) => key === selectedKey);
    
      // If the key is found, slice the array to keep only the entries up to the selected key
      const newEntries = selectedIndex !== -1 ? entries.slice(0, selectedIndex + 1) : entries;
    
      // Convert the array of entries back into an object
      return Object.fromEntries(newEntries);
    },
    async deleteAfterKeyarrays(selectedKey) {

      let index = this.historykeys.indexOf(selectedKey);

if (index !== -1) {
    // Slice the array up to the element (including the element)
    this.historykeys = this.historykeys.slice(0, index + 1);
}
    },
    async headderforbarcomparitive(repfieldname) {
      this.comparitivebarheader = repfieldname;
    },
    async getquerydata(){
        const currentstudy = await store.getters.getStudyIs;
        const idtoken = store.getters.getIdToken;
        await axios.get(
          `${this.basetestUrl}/forms/query/getqueryreports?studyId=${currentstudy}`,
          {
              headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
              }
          })
          .then((res) => {
            this.querydata = res.data;
            this.loader = false;
          })
          .catch((err) => console.log("error in screen list", err));
    },

    async pageclosed(){
      this.$router.push(`/studymonitoring`);
    }
  },
};